<template>
  <div class="table-wrapper">
    <reports-filter v-if="getterPopupName === 'ReportsFilter'"
              :txnOptions="txnOptions" @updateFilters="filterTxnsCount" />
    <reports-export v-else-if="getterPopupName === 'ReportsExport'"
              :exportOptions="filters" :exportRecords="exportRecords" />

    <div class="table-title">
      <div class="subject">
        <p>Report Exports</p>
        <span v-if="typeof paginate.total === 'number'">
          Total ({{paginate.total}})
        </span>
      </div>

      <div class="filters">
        <div class="options">
          <button @click="openPopup('ReportsFilter')" v-if="txnOptions.length"
            class="dark-btn">
            Export Transactions
            <i class="fa fa-share" />
          </button>
        </div>
      </div>
    </div>

    <div class="table-head" v-if="isDesktop()">
      <p class="d-s">ID</p>
      <p class="text-left">Report Type</p>
      <p class="d-xl text-left">Filters</p>
      <p>Status</p>
      <p></p>
    </div>

    <div class="table-body">
      <div class="table-row" v-for="(data, index) in list" :key="index">
        <p class="mt-grey-text d-s">
          <b v-if="!isDesktop()">ID:</b>
          {{data.id}}
        </p>
        <p class="mt-grey-text mt-col-span2 text-left">
          <b v-if="!isDesktop()">Report Type:</b>
          {{data.purpose}}
        </p>
        <p class="d-xl mt-col-span2">
          <span v-for="(filter, filterIndex) in data.filter" :key="filterIndex">
            <b>{{filter.title}}</b>:
            <strong>{{filter.value}}</strong>
          </span>
        </p>
        <p class="mt-grey-text">{{data.status}}</p>
        <p v-if="data.status === 'COMPLETED'" class="download mt-col-span2"
            @click="download(data.id)">
          <i class="fa fa-download" v-if="!isDesktop()" />Download
        </p>
        <p v-else-if="isDesktop()"></p>
      </div>
    </div>

    <table-loader v-if="!paginate.data_added || list.length < paginate.total"
                  :css="{'single-side': !isDesktop()}" />

    <div class="table-empty" v-if="paginate.total === 0">
      <p>{{emptyRecords}}</p>
    </div>
  </div>
</template>

<script>
import ReportsFilter from '@/components/AccountStatement/StatementFilter'
import ReportsExport from '@/components/global/ExportConfirmation'

import ApiServices from '@/services/api/reports'
import TxnServices from '@/services/api/accountStatement'
import ListMixins from '@/mixins/listMixins'
import { FilterBuilder } from '@/utils/helpers/classes'

export default {
  name: 'Reports',
  components: { ReportsFilter, ReportsExport },
  mixins: [ListMixins],
  data () {
    return {
      txnOptions: [],
      filters: {}
    }
  },
  created () {
    this.populateParams()
    this.populateData()
  },
  methods: {
    populateParams () {
      this.keys['list'] = 'reports'
      this.paginate['type'] = 'Export'
    },
    fetchRecords (start) {
      return new Promise(resolve => {
        let params = {}
        if (start) {
          params['offset'] = start
        }

        let filterData = new FilterBuilder()
        ApiServices.reportsList(params).then((response) => {
          let data = response.data
          data.reports = data.reports.map(entry => {
            let filterOptions = entry.filter
            let filters = []

            if (entry.purpose === 'TRANSACTION_EXPORT' && !filterOptions.txn_type && !filterOptions.txn_types && !filterOptions.q) {
              filters.push({
                title: 'Transaction Types',
                value: 'ALL'
              })
            }
            filterData.process(filters, filterOptions, entry.purpose)

            entry.filter = filters
            return entry
          })

          if (start) {
            this.list.push(...data.reports)
          } else {
            this.list = data.reports
            this.txnOptions = data.transaction_types
            this.setPaginate(data)
          }
          resolve()
        })
      })
    },
    download (id) {
      ApiServices.reportsUrl(id).then((response) => {
        location.href = response.data.download_url
      })
    },
    filterTxnsCount (params) {
      TxnServices.filterTxnsCount(params).then(response => {
        if (response.reason === 'UNPRIVILEGED' || response.privileges_changed) {
          this.errorToastMsg(response.message)
          this.openPopup(null)
        } else {
          this.filters = response.data
          this.openPopup('ReportsExport')
        }
      })
    },
    exportRecords () {
      TxnServices.exportStatements({next_page_token: this.filters.next_page_token}).then(response => {
        this.openPopup(null)

        if (response.reason === 'UNPRIVILEGED' || response.privileges_changed) {
          this.errorToastMsg(response.message)
        } else {
          this.resetData()
          this.successToastMsg(response.message)
          this.populateData()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/table.scss';

  .table-body {
    p {
      span {
        display: flex;
        text-align: left;
        margin-bottom: 6px;

        &:last-child {
          margin-bottom: 0 !important;
        }

        b {
          font-weight: 600 !important;
          min-width: 125px;
          margin-right: 10px;
        }
        strong {
          font-weight: 400 !important;
          margin-left: 8px;
        }
      }
    }
  }

  .text-left {
    text-align: left;
  }

  .desktop {
    .table-row {
      align-items: baseline !important;
    }
    .d-s {
      flex: .5 !important;
    }
  }

  .tablet, .mobile {
    .table-row {
      p {
        white-space: unset !important;
      }
    }
  }
</style>
